module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__errorRed--dark-4410d9d57d72a965297f0ab034d8d28e.png";